// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__Eo13R","deleteBtnColor":"style_deleteBtnColor__VmK56"};